import React, { useMemo } from 'react';
import { TPA_EXPERIMENTS } from '@wix/pricing-plans-common/experiments';
import { VIEWER_HOOKS } from '@wix/pricing-plans-common/hooks';
import { useStyles } from '@wix/tpa-settings/react';
import { useEnvironment, useExperiments } from '@wix/yoshi-flow-editor';
import { useIsHydrated, useStylesParams } from '../../../../../hooks';
import { useDynamicElement } from '../../../../../hooks/useDynamicElement';
import { st, classes } from './Tagline.st.css';

interface Props {
  planId: string;
  description: string;
  highlighted: boolean;
  className?: string;
}

export const Tagline: React.FC<Props> = ({ planId, description, highlighted, className }) => {
  const { isMobile } = useEnvironment();
  const { experiments } = useExperiments();
  const { registerRef, heightByPlanId } = useDynamicElement('tagline');
  const isHydrated = useIsHydrated();
  const styles = useStyles();
  const stylesParams = useStylesParams();
  const fontSize = styles.get(stylesParams.planTaglineFontSize);
  const isFontSizeEnabled = experiments.enabled(TPA_EXPERIMENTS.FONT_SIZE_FOR_TPA_ELEMENTS);

  const ref = useMemo(() => registerRef(planId), [planId]);
  const dynamicHeight = useMemo(() => ({ height: heightByPlanId.get(planId) }), [heightByPlanId, planId]);

  return (
    <div
      data-hook={VIEWER_HOOKS.PLAN_TAGLINE}
      className={st(classes.tagline, { highlighted, mobile: isMobile }, className)}
      // setting inline styles causes react to re-render component on hydration, so ony set after hydration
      style={!isMobile && isHydrated ? dynamicHeight : {}}
    >
      <div ref={!isMobile ? ref : undefined} style={isFontSizeEnabled ? { fontSize: `${fontSize}px` } : undefined}>
        {description}
      </div>
    </div>
  );
};
